import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import DropDown from './dropDown';
import categoryPaths from '../constants/categoryPaths';
import styles from '../styles/components/categoriesDropDown.module.scss';

const CategoriesDropDown = ({ intl }) => {
  const currentLanguage = intl.locale;

  const title = {
    messageId: 'categories.title',
  };

  const options = Object.keys(categoryPaths).map((category) => {
    let style;
    if (category === 'noMoreViolence') {
      style = styles.noMoreViolence;
    }
    const path = categoryPaths[category][currentLanguage];
    return {
      url: `${currentLanguage}/${path}`,
      messageId: `category.${category}`,
      style,
    };
  });

  return (
    <DropDown
      containerStyles={styles.container}
      contentStyles={styles.content}
      options={options}
      title={title}
    />
  );
};

CategoriesDropDown.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(CategoriesDropDown);

